<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="sam-margin">
   <fa-icon [icon]="icon" size="3x"></fa-icon>
   <span class="sam-margin sam-text-center">
      {{ 'brick.brick-management.brick-not-found' | translate }}
   </span>
</div>
